export default "__VITE_ASSET__DKI4eS59__"